export type Features = {
  marketplace: boolean;
  sanctuary: boolean;
  payments: boolean;
};

export const Config = {
  API_BASE_URL: (() => {
    const fromEnv = import.meta.env.VITE_API_BASE_URL as string | undefined;
    if (fromEnv) return fromEnv;
    const host = window.location.hostname;
    if (host.includes('pages.dev') || host === 'urbanlife.works' || host === 'www.urbanlife.works') {
      return 'https://api.urbanlife.works';
    }
    return 'http://localhost:8000';
  })(),
  features: {
    marketplace: true,
    sanctuary: true,
    payments: true,
  } as Features,
};
